import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=4137e794&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=4137e794&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4137e794",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4137e794')) {
      api.createRecord('4137e794', component.options)
    } else {
      api.reload('4137e794', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=4137e794&scoped=true", function () {
      api.rerender('4137e794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/proposalProcess/components/ProposalDetails/Main.vue"
export default component.exports